import React, { useState } from 'react';
import Form from '../../Modules/form/components/Form';
import { Card, CardBody, FormGroup, Row, Col, Label, Button} from 'reactstrap';
import Box from '@material-ui/core/Box';

import DateInput from '../../Modules/form/components/DateInput';
import AgencySelect from '../../Modules/form/components/specialized/AgencySelect';
import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';

const FORM_KEY = 'price-increases-export';
const EXPORT_TYPE = 'priceincreases';

const PriceIncreasesExport = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleExportSubmit = async (values) => {
        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, values);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return  (
            <Box mt={3}>
                <Card data-cy="card-cancellation-reason-export">
                    <h6 className="card-header">Übersicht-Preiserhöhungen Excel-Datei</h6>
                    <CardBody>
                        <p>
                            Unter folgendem Link kann die Datei für die Übersicht-Preiserhöhungen heruntergeladen
                            werden.
                        </p>
                        <Form onSubmit={handleExportSubmit}>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <DateInput
                                            label="Zeitraum vom:"
                                            name="date_from"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <DateInput
                                            label="bis:"
                                            name="date_till"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Agentur:</Label>
                                        <AgencySelect
                                            name="agency"
                                            label="Agentur"
                                            fullWidth
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <div className="text-center">
                                <LoadingButton
                                    color="primary"
                                    id={FORM_KEY}
                                    title="Klicken um die Datei herunterzuladen"
                                    type="submit"
                                    isLoading={loading}
                                >
                                Herunterladen
                                </LoadingButton>
                            </div>
                            {error && <div className="text-danger">{error.message}</div>}
                            <div>
                                <Button type="reset" color="secondary" className="ml-2">
                                    Zurücksetzen
                                </Button>
                            </div>

                        </Form>
                    </CardBody>
                </Card>
            </Box>
        )
};

PriceIncreasesExport.propTypes = {

};

PriceIncreasesExport.defaultProps = {

};

export default PriceIncreasesExport
